import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchData(ctx, queryParams) {
            var data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .post('/component/v1/group/getall',data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
        addData(ctx, queryParams){
            var data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .post('/component/v1/group/add',data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })

        },
     
        updateData(ctx, queryParams){
            console.log('queryParams',queryParams);
             var data = JSON.stringify(queryParams);
            return new Promise((resolve, reject) => {
                axios
                  .put('/component/v1/group/update/'+queryParams.id,data)
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })

        },
        DeleteData(ctx,id){
            return new Promise((resolve, reject) => {
                axios
                  .delete('/component/v1/group/delete/'+id)
                  .then(response => resolve(response))
                  .catch(error => reject(error))
              })
        }
    }
}